/* eslint-disable react/prop-types */
import React from 'react';

import './AuHeading.scss';

type HTMLHeadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface IAuHeading {
  level: '1' | '2' | '3' | '4' | '5' | '6';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
  className?: string;
  style?: React.CSSProperties;
}

/**
 * DEFAULT
 * The headings component
 */
const AuHeading: React.FC<IAuHeading> = ({ level, children, size = 'lg', className = '', ...attributeOptions }) => {
  const HeadingTag: HTMLHeadingType = `h${level}` as HTMLHeadingType;

  return (
    <HeadingTag className={`au-display-${size} ${className}`} {...attributeOptions}>
      {children}
    </HeadingTag>
  );
};

export default AuHeading;